// extracted by mini-css-extract-plugin
export var circle = "_30-2";
export var icon = "_30-a";
export var iconHighlight = "_30-0";
export var lg = "_30-8";
export var md = "_30-7";
export var outline = "_30-4";
export var sm = "_30-6";
export var square = "_30-1";
export var xl = "_30-9";
export var xs = "_30-5";
export var xxs = "_30-3";